import React from "react";
import { FeaturedDesigners } from "@tkww/component-fashion-featured-designers";
const FeaturedDesignersComponent = ({ designers }) => {
  return <FeaturedDesigners featuredDesigners={designers} />;
};

export default FeaturedDesignersComponent;
